export default "__VITE_ASSET__C7Qz9oSd__"